import { getMoveErrorI18nKey, MOVE_GENERIC_ERROR_I18N_KEY } from './moveErrors';

// Mirrors the backend (next/src/utils/auth/helpers.js): an admin is a
// `user_admin` or a superadmin, and superadmins are identified by role name.
const SUPER_ADMIN_ROLES = ['superadmin', 'super_admin'];
const CREDIT_CAMPAIGN_ROLE = 'credit_campaign';
const PARTNER_ERROR_KEY = 'move_partner_campaign_not_allowed';

const hasRole = (user, role) =>
  Array.isArray(user && user.roles) && user.roles.includes(role);

export const canMoveCandidates = (user) =>
  Boolean(user && user.user_admin) ||
  SUPER_ADMIN_ROLES.some((role) => hasRole(user, role)) ||
  hasRole(user, CREDIT_CAMPAIGN_ROLE);

// The move flow lists CONDUCT invitations only (IE ones follow their CONDUCT),
// so a campaign with none has nothing to move (NW-2675). Not derived from
// `credits_assigned`: that counter can drift from the real invitations.
export const countMovableCandidates = (campaign) =>
  (campaign?.nwm_invitation || []).filter((i) => i.type === 'CONDUCT').length;

// Availability of the "Mover candidatos" button from the destinations request
// and the source candidates. `messageKey` is the i18n key of the explanatory
// popup (null = no popup).
export const getMoveButtonState = (
  status,
  destinations,
  errorKey,
  candidateCount = 1,
) => {
  if (!status || status.loading) return { disabled: true, messageKey: null };
  if (status.error) {
    return {
      disabled: true,
      messageKey:
        errorKey === PARTNER_ERROR_KEY
          ? getMoveErrorI18nKey(errorKey)
          : MOVE_GENERIC_ERROR_I18N_KEY,
    };
  }
  if (!status.success) return { disabled: true, messageKey: null };
  if (!destinations || destinations.length === 0) {
    return {
      disabled: true,
      messageKey: 'campaigns.move.insufficientCampaigns',
    };
  }
  if (candidateCount === 0) {
    return { disabled: true, messageKey: 'campaigns.move.noCandidates' };
  }
  return { disabled: false, messageKey: null };
};
